import React from 'react';
import styles from './HomeCard.module.css';
import ContentBanner from '../ContentBanner/ContentBanner';

const HomeCard = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.cardTitle}>Available Now</div>
      <div className={styles.homeCard}>
        <ContentBanner
          item={data}
          carouselType='home-card'
          itemDirection='rtl'
          alignItems='start'
          height='auto'
          padding={0}
          detailOrder={['title', 'tags', 'description', 'actions']}
          buttonActions={[
            {
              label: 'Watch Now',
              icon: 'play',
              iconStyle: {
                backgroundColor: '#F49832',
                borderRadius: '50%',
              },
              textColor: 'primary',
              type: 'text',
              size: 'large',
              onclick: 'play',
            },
            {
              label: 'More Info',
              icon: 'info',
              iconStyle: {
                backgroundColor: '#fff',
                borderRadius: '50%',
              },
              textColor: 'primary',
              type: 'text',
              size: 'large',
              onclick: 'detail',
            },
          ]}
          showBannerBackground={false}
        />
      </div>
    </div>
  );
};

export default HomeCard;
